var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnsisLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9464 3.10633L2.58047 5.34012V6.7735H11.4195V5.34522L6.9464 3.10633ZM2.58047 9.35664H12.3246C13.249 9.35664 14 8.60489 14 7.67952V4.8265C14 4.15991 13.6241 3.56061 13.0364 3.26646L7.72144 0.606214C7.2182 0.354332 6.6626 0.389462 6.23178 0.574289L6.19168 0.591493L0.956847 3.26985C0.373012 3.56519 0 4.16246 0 4.8265V12.8844C0 13.4427 0.293947 14.0399 0.864945 14.3461L6.21004 17.3788L6.24005 17.3938C6.71882 17.6334 7.28117 17.6334 7.75995 17.3938L7.78996 17.3788L13.194 14.3127L13.2329 14.2867C13.6128 14.0332 14 13.5537 14 12.8844V10.5325H11.4195V12.3503L7 14.8578L2.58047 12.3503V9.35664Z",
    fill: "#7139B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.44543 12.3438H12.0163L7.4138 15.2739L2.44543 12.3438Z",
    fill: "#7139B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnsisLogoIcon);
export default __webpack_public_path__ + "static/media/ensis-logo-icon.159fe6fb982175ab9a99a68dbe22d1a0.svg";
export { ForwardRef as ReactComponent };